<template>
  <div class="login-container">
    <img class="BKG" src="../../image/bg.webp" />

    <div class="center-box">
      <div class="login-box">
        <div class="logo">
          <div>
            <span class="brand">小程序后台管理系统</span>
          </div>
        </div>
        <div class="login-form">
          <div class="title_l">{{ isActive === 0 ? "登录" : "注册账号" }}!</div>
          <div v-if="isActive === 1">
            <el-input
              v-model="username"
              placeholder="手机号"
              class="username"
              maxlength="11"
              clearable
            ></el-input>
            <el-input
              placeholder="请输入密码"
              :type="flag ? 'text' : 'password'"
              v-model="password"
              maxlength="18"
              class="username"
              clearable
            >
              <i
                slot="suffix"
                :class="[flag ? 'el-icon-sunny' : 'el-icon-cloudy']"
                class="password_icon"
                autocomplete="auto"
                @click="flag = !flag"
              />
            </el-input>
            <div style="position: relative">
              <el-input v-model="verCode" placeholder="验证码" class="verCode" clearable></el-input>
              <el-button
                class="getCode"
                @click="handleGetCode"
                :disabled="disabled"
              >{{ codeBtnTitle }}</el-button>
            </div>
          </div>

          <div v-else>
            <el-input
              v-model="username"
              placeholder="请输入账号"
              class="username"
              maxlength="11"
              clearable
            ></el-input>
            <el-input
              placeholder="请输入密码"
              :type="flag ? 'text' : 'password'"
              v-model="password"
              maxlength="18"
              class="username"
              clearable
            >
              <i
                slot="suffix"
                :class="[flag ? 'el-icon-sunny' : 'el-icon-cloudy']"
                class="password_icon"
                autocomplete="auto"
                @click="flag = !flag"
              />
            </el-input>
          </div>

          <div class="rememberBtn">
            <el-checkbox v-model="passwordChecked">记住{{ isActive === 0 ? "账号密码" : "手机号" }}</el-checkbox>
            <!-- <div class="link" @click="linkLogin">扫码登录</div> -->
          </div>

          <el-button
            type="primary"
            class="loginBtn"
            @click="handleSave"
            v-loading.fullscreen.lock="fullscreenLoading"
            v-waves
          >{{ isActive === 0 ? "登录" : "注册" }}</el-button>
          <!-- <el-button
            type="primary"
            class="loginBtn"
            @click="activeBtn"
            v-loading.fullscreen.lock="fullscreenLoading"
            v-waves
            >{{ isActive === 0 ? "注册账号" : "返回登录" }}</el-button
          >-->
        </div>
      </div>
      <!-- 标语 -->
      <div class="life">
        <div class="h1">上海澳特悉网络科技有限公司提供技术支持</div>
        <div class="h2">Shanghai Aotexi Network Technology Co., Ltd. support</div>
      </div>
    </div>
  </div>
</template>

<script>
import { loginApi } from "@/services/systemPage/admin_user.js";
import { mapActions } from "vuex";
export default {
  computed: {},
  created() {
    //1记住密码  0不记住密码
    if (localStorage.getItem("passwordChecked") == 1) {
      this.passwordChecked = true;
      // 账号回显
      var loginForm = JSON.parse(localStorage.getItem("loginForm"));
      // console.log(loginForm);
      if (loginForm !== null) {
        this.username = loginForm.username;
        this.password = loginForm.password;
      }
    } else {
      this.passwordChecked = false;
    }
  },
  data() {
    return {
      flag: false,
      fullscreenLoading: false,
      username: "", //用户名或手机号
      verCode: "", //验证码
      password: "", //密码
      passwordChecked: "",
      codeBtnTitle: "验证码",
      disabled: false,
      loginStyle: ["账号登录", "手机号登录"],
      isActive: 0
    };
  },
  watch: {},
  methods: {
    ...mapActions(["getUserInfoAction"]),
    activeBtn() {
      if (this.isActive === 0) {
        this.isActive = 1;
      } else {
        this.isActive = 0;
      }
    },
    /* 计时器 */
    timer() {
      let s = 60;
      this.codeBtnTitle = s + " s";
      this.disabled = true;
      let timer = setInterval(() => {
        s--;
        this.codeBtnTitle = s + " s";
        if (s === 0) {
          clearInterval(timer);
          this.codeBtnTitle = "验证码";
          this.disabled = false;
        }
      }, 1000);
    },
    /* 获取验证码 */
    async handleGetCode() {
      let reg_tel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      // console.log(reg_tel.test(this.username));
      if (!reg_tel.test(this.username)) {
        this.$message.error("请输入正确的手机号");
        return;
      }
      const result = await getCode({ username: this.username });
      if (result.code === 200) {
        this.$message.success("验证码已发送");
        this.timer();
      }
    },

    handleSave() {
      const verCode = this.verCode;
      const password = this.password;
      const username = this.username;
      // 记住密码监听
      if (this.passwordChecked) {
        //将用户数据存到localStorage 长期有效 （cooking不设置时效关闭浏览器就消失了 设置才长期有效）
        localStorage.setItem("passwordChecked", 1);
        let loginForm = {
          username,
          password
        };
        localStorage.setItem("loginForm", JSON.stringify(loginForm));
      } else {
        localStorage.setItem("passwordChecked", 0);
        localStorage.removeItem("loginForm");
      }
      if (!username || !password) {
        this.$message.error("账号或密码不能为空");
        return;
      }
      if (this.isActive == 0) {
        this.loginBtn();
        return;
      }
      if (this.isActive == 1 && !verCode) {
        this.$message.error("验证码不能为空");
        return;
      }
      this.handleRegister(); // 注册
    },

    /* 登录 */
    loginBtn() {
      this.fullscreenLoading = true;
      loginApi({
        username: this.username,
        password: this.password
      })
        .then(res => {
          if (res.code === 200) {
            localStorage.setItem("token", res.data); // 保存令牌
            this.$message.success("登录成功");
            this.fullscreenLoading = false;
            this.$router.push({ name: "Welcome" });
          } else {
            setTimeout(() => {
              this.fullscreenLoading = false;
            }, 1000);
          }
        })
        .catch(err => {
          this.fullscreenLoading = false;
        });
    },

    /* 注册 */
    async handleRegister() {
      this.fullscreenLoading = true;
      const result = await register({
        username: this.username,
        password: this.password,
        code: this.verCode
      });
      this.fullscreenLoading = false;
      if (result.code === 200) {
        this.getUserInfoAction().then(res => {
          if (res.code === 200) {
            this.$message.success("注册账号成功");
          }
          this.$router.push({ name: "Welcome" });
        });
      }
    }
  }
};
</script>

<style lang="less" scoped>
.login-container {
  background: rgb(255, 255, 255);
  height: 100%;
  width: 100%;
  position: fixed;
  .BKG {
    width: 100%;
    height: 100vh;
    opacity: 0.2;
  }
  .center-box {
    min-height: 500px;
    width: 450px;
    // height: 520px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    animation-name: move;
    animation-duration: 1s;
    display: flex;
  }
  @keyframes move {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
}

/* 登录box */
.login-box {
  position: relative;
  width: 100%;
  height: 100%;
  background: white;
  border-radius: 30px;
  box-shadow: 0 0 10px 0 rgba(88, 88, 88, 0.1);
  // border: 1px solid #000000;
  padding: 20px 0;
  .logo {
    margin: 25px auto;
    display: flex;
    align-items: center;
    font-size: 1.2em;
    letter-spacing: 2px;
    font-weight: 800;
    height: 60px;
    text-align: center;
    justify-content: center;
  }
  .brand {
    font-size: 22px;
  }
  .login-form {
    width: 80%;
    margin: 0 auto;
    padding: 0 30px;
    border-radius: 20px;
    // border: 1px solid red;
    .title_l {
      margin: 20px 0;
      font-weight: 800;
      font-size: 1.2em;
    }
    .password_icon {
      position: absolute;
      font-size: 16px;
      right: 30px;
      top: 12.5px;
    }
    .password_icon:hover {
      cursor: pointer;
      color: #111111ca;
    }
    /* 登录方式切换 */
    .loginStyle {
      display: flex;
      width: 100%;
      margin: 10px auto;
      color: #6b6b6b;
    }
    .active {
      color: #afc7d6 !important;
      font-weight: 550;
    }

    .loginStyle > div {
      margin: 20px 15px 20px 0px;
    }
    .loginStyle > div:hover {
      cursor: pointer;
    }
    .username {
      margin: 20px auto;
      width: 100%;
      display: block;
      position: relative;
    }
    .verCode {
      display: block;
      margin: 10px auto;
      width: 100%;
    }
    .getCode {
      position: absolute;
      top: 0px;
      right: 0;
      width: 85px;
    }
    .rememberBtn {
      margin: 0 auto;
      width: 100%;
    }
    /deep/ .el-checkbox__input.is-checked .el-checkbox__inner {
      background-color: #65d27d !important;
      border-color: #65d27d !important;
    }
    /deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
      color: #65d27d;
    }
    .loginBtn {
      background: #65d27d;
      margin: 20px auto;
      width: 100%;
      display: block;
      border: none;
    }
    // .loginBtn:last-child {
    //   margin-top: -10px !important;
    //   background: #ffffff !important;
    //   border: 1px solid #65d27d !important;
    //   color: #65d27d !important;
    // }
  }
}

.life {
  position: absolute;
  left: 0;
  right: 0;
  bottom: -80px;
  text-align: center;
  font-weight: 200;
  .footer {
    letter-spacing: 3px;
    color: #7f7f7f;
  }
}
</style>
